'use client';

import type {ReactNode} from 'react';

const LoginLayout = ({children}: {children: ReactNode}) => {
  return (
    <div className="center h-screen">
      <div className="flex flex-col items-center w-full sm:w-96">
        <div className="py-0 sm:py-8 px-4 sm:px-10 w-full flex justify-center">{children}</div>
      </div>
    </div>
  );
};

export default LoginLayout;
